module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "单位名称",
      "input-align": "right",
      "placeholder": "请输入单位名称"
    },
    on: {
      "click-left-icon": function($event) {
        return _vm.onQuestion('name')
      }
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "描述",
      "type": "textarea",
      "placeholder": "请输入描述",
      "rows": "1"
    },
    on: {
      "click-left-icon": function($event) {
        return _vm.onQuestion('desc')
      }
    },
    model: {
      value: (_vm.formData.desc),
      callback: function($$v) {
        _vm.$set(_vm.formData, "desc", $$v)
      },
      expression: "formData.desc"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "left-small-label"
  }, [_vm._v("\n        LOGO\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "right-img"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.pic,
      "limit": 1,
      "name": 'pic'
    },
    on: {
      "imageListChange": _vm.imageListChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip-text"
  }, [_vm._v("显示在列表页,推荐尺寸750x750,推荐格式jpg")])], 1)]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "clearable": "",
      "input-align": "right",
      "label": "联系电话",
      "placeholder": "请输入商家联系电话"
    },
    on: {
      "click-left-icon": function($event) {
        return _vm.onQuestion('phone')
      }
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "地址",
      "input-align": "right",
      "error": _vm.formValidate && !_vm.formData.address,
      "placeholder": "请输入地址",
      "required": ""
    },
    on: {
      "click-left-icon": function($event) {
        return _vm.onQuestion('address')
      }
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "clearable": "",
      "input-align": "right",
      "label": "微信号",
      "placeholder": "请输入微信号"
    },
    on: {
      "click-left-icon": function($event) {
        return _vm.onQuestion('phone')
      }
    },
    model: {
      value: (_vm.formData.order_add_friend_code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "order_add_friend_code", $$v)
      },
      expression: "formData.order_add_friend_code"
    }
  })], 1), _vm._v(" "), (_vm.formData.open_order_add_friend == 1) ? _c('div', {
    staticClass: "select-check"
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "clearable": "",
      "label": "微信号",
      "placeholder": "请输入微信号",
      "left-icon": "question-o"
    },
    on: {
      "click-left-icon": function($event) {
        return _vm.onQuestion('order_add_friend_code')
      }
    },
    model: {
      value: (_vm.formData.order_add_friend_code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "order_add_friend_code", $$v)
      },
      expression: "formData.order_add_friend_code"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "left-small-label"
  }, [_c('van-icon', {
    staticClass: "question-icon",
    attrs: {
      "name": "question-o"
    },
    on: {
      "click": function($event) {
        return _vm.onQuestion('order_add_friend_pic')
      }
    }
  }), _vm._v("\n          二维码\n        ")], 1), _vm._v(" "), _c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.order_add_friend_pic,
      "limit": 9,
      "name": 'order_add_friend_pic'
    },
    on: {
      "imageListChange": _vm.imageListChange
    }
  })], 1), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "clearable": "",
      "label": "话术",
      "placeholder": "请输入话术"
    },
    model: {
      value: (_vm.formData.order_add_friend_text),
      callback: function($$v) {
        _vm.$set(_vm.formData, "order_add_friend_text", $$v)
      },
      expression: "formData.order_add_friend_text"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [(!_vm.saveLoading) ? _c('van-button', {
    attrs: {
      "type": "danger",
      "size": "large"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")]) : _c('van-button', {
    attrs: {
      "type": "danger",
      "size": "large"
    }
  }, [_vm._v("保存中...")])], 1), _vm._v(" "), _c('div', {
    staticClass: "line",
    staticStyle: {
      "height": "50px"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aad4ce68","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/weiyuanhui/site/SiteSettingBase.vue
// module id = 2571
// module chunks = 0